module.exports = __webpack_public_path__ + "static/img/human-2.a63c07a6.png";